import { STATE_INITIAL } from 'Store/commonActions';

import type { MMState } from './types';

const initialState: MMState = {
  errorState: null,
  friendBirthday: null,
  friendName: null,
  invitationId: null,
  inviteValidationStatus: STATE_INITIAL,
  isLoadingRecsPack: true,
  benefactorGender: -1,
  benefactorName: null,
  benefactorImageUrl: null,
  recsPackResponse: null,
  introSheetShown: false,
  shouldShowFriendModal: true,
  wasMMOnboardingDisplayed: false,
};

export default initialState;
